<style scoped lang="less">
@import "./style.less";
</style>
<script>
import methods from './methods.js'

export default {
  name: "chart",
  mixins: [methods]
}
</script>
<template>
  <none-data :height="3.5" v-if="isEmpty"></none-data>
  <div class="barChart" v-else>
    <transition-group name="bar-list" tag="div" >
      <div class="barChart__item" v-for="bar of list" :key="bar.name">
        <!--   字   -->
        <div class="barChart__item__top">
          <div class="barChart__item__top__left">
            <div class="barChart__item__top__title">{{bar.name}}</div>
            <div class="barChart__item__top__percent">占比 {{bar.percent}}</div>
          </div>
          <div class="barChart__item__top__value">{{bar.value}}</div>
        </div>
        <!--  图    -->
        <div class="barChart__item__bar">
          <div class="barChart__item__bar__trunk" />
          <div class="barChart__item__bar__line" :style="`width:${bar.lineLength}`"/>
        </div>
      </div>
    </transition-group>
  </div>
</template>

